import script from "./FileReportTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileReportTable.vue?vue&type=script&setup=true&lang=ts"

import "./FileReportTable.vue?vue&type=style&index=0&id=26d2ad19&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d2ad19"]])

export default __exports__